export const orderAppearanceDefaults = {
  checkout: { titleSize: 30, sectionTitleSize: 20, labelSize: 16, textSize: 16, amountSize: 28, titleColor: "#0f172a", textColor: "#475569", surfaceColor: "#ffffff", accentColor: "#4f46e5", borderColor: "#e2e8f0", showTopText: true, topText: "اطلاعات ارسال را بررسی کنید، سپس روش پرداخت را انتخاب کنید." },
  invoice: { titleSize: 30, sectionTitleSize: 20, labelSize: 16, textSize: 18, amountSize: 28, titleColor: "#0f172a", textColor: "#475569", surfaceColor: "#ffffff", accentColor: "#4f46e5", borderColor: "#e2e8f0", showTopText: true, topText: "فروشگاه آکادمی هنری مینا" },
};

export function normalizeOrderAppearance(value) {
  return Object.fromEntries(Object.entries(orderAppearanceDefaults).map(([page, defaults]) => {
    const source = value && typeof value[page] === "object" && value[page] !== null ? value[page] : {};
    const result = { ...defaults };
    for (const key of Object.keys(defaults)) {
      const input = source[key];
      if (key.endsWith("Size")) {
        const number = typeof input === "number" || typeof input === "string" ? Number(input) : NaN;
        if (Number.isFinite(number) && number >= 12 && number <= 48) result[key] = number;
      } else if (key.endsWith("Color")) {
        if (typeof input === "string" && /^#[0-9a-f]{6}$/i.test(input.trim())) result[key] = input.trim();
      } else if (key === "showTopText") {
        if (typeof input === "boolean") result[key] = input;
      } else if (typeof input === "string" && input.trim()) result[key] = input.trim().slice(0, 1000);
    }
    return [page, result];
  }));
}
